"use client";
import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { Toast } from "primereact/toast";
import storageService from "@/services/StorageService";
//custom components
import Input from "../common/Input";
import PasswordInput from "../common/PasswordInput";
import Button from "../common/Button";
//api
import { SignIn, userRegister } from "@/app/api/auth/route";
import Link from "next/link";
import { loginThunk } from "@/redux/store/slices/authSlice";
import { useAppDispatch } from "@/redux/store/hook";
import { debug } from "console";
import { messaging } from "../../../lib/firebase";
import { getToken, onMessage } from "firebase/messaging";

const LoginForm = () => {
    const dispatch = useAppDispatch();
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const toast = useRef<Toast>(null);
    const router = useRouter();
    const [contact, setContact] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState<{ contact?: string; password?: string }>({});
    const [fcmToken, setFcmToken] = useState('')
    useEffect(() => {
        initNotification();
    }, []);
    const initNotification = async () => {
        if (!messaging) return;

        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: "BPOS8DeUHjVzNVpD2KpqSeU5TUKsinoXLmQVQoObqZWFAW-ntIiVBx49FrNI4egOdZC73-1rvR-6hTndFctOV34",
            });
            console.log("FCM Token login:", token);
            setFcmToken(token)
        }
    };

    // Foreground messages
    useEffect(() => {
        if (!messaging) return;
        onMessage(messaging, (payload) => {
            console.log(payload, 'notification get')
            alert(
                payload.notification?.title + " - " + payload.notification?.body
            );
        });
    }, []);
    //handleChange
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, field: "contact" | "password") => {
        let { value } = e.target;
        if (field === "contact") {
            value = value.replace(/\D/g, "");
            if (value.length > 10) return;
            setContact(value);
        }
        if (field === "password") setPassword(value);
        setErrors((prev) => ({ ...prev, [field]: undefined }));
    };

    //validation
    const validate = () => {
        const newErrors: typeof errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[6-9]\d{9}$/;
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).{8,}$/;
        // contact validation
        if (!contact) newErrors.contact = 'Mobile number is required';
        else if (!mobileRegex.test(contact)) newErrors.contact = 'Enter valid 10-digit mobile number';
        // Password validation
        if (!password) {
            newErrors.password = "Password is required";
        } else if (!passwordRegex.test(password)) {
            newErrors.password = "Password must be at least 8 characters, include one uppercase letter, one lowercase letter, and one number";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const userRegisterData = () => {
        const payload = {
            deviceToken: fcmToken,
            platform: "web"
        }
        console.log(payload, 'payload...')
        try {
            const response = userRegister(payload)
            console.log(response, 'response..')
        } catch (errors) {
            console.log(errors, 'errors. in notification')
        } finally {

        }

    }

    const registerDeviceToken = async () => {
        if (!messaging) return;

        try {
            const permission = await Notification.requestPermission();

            if (permission === "granted") {
                const token = await getToken(messaging, {
                    vapidKey:
                        "BPOS8DeUHjVzNVpD2KpqSeU5TUKsinoXLmQVQoObqZWFAW-ntIiVBx49FrNI4egOdZC73-1rvR-6hTndFctOV34",
                });

                if (token) {
                    console.log("FCM Token login:", token);

                    // Send the token to your backend to associate with the logged-in user
                    await userRegister({ deviceToken: token, platform: "web" });
                } else {
                    console.warn("FCM token not received");
                }
            } else {
                console.warn("Notification permission denied");
            }
        } catch (error) {
            console.error("Error getting FCM token:", error);
        }
    };


    //handleLogin
    const handleLogin = async () => {
        if (!validate()) return;
        setIsLoading(true);
        const loginData = {
            mobileNo: contact,
            password: password,
        };
        try {
            // Get the response data directly
            // const response = await SignIn(loginData);
            const response = await dispatch(loginThunk(loginData)).unwrap();
            // userRegisterData()
            debugger;
            console.log(response, 'response..')
            if (response?.status) {
                registerDeviceToken()
                const UserRole = response?.user?.role?.name;
                // storageService.set("userRole", UserRole || "");
                // storageService.set("token", response?.accessToken || "");
                // storageService.set("userData", response?.user || "");
                if (UserRole === "SuperAdmin") {
                    router.push("/dashboard");
                    toast.current?.show({ severity: "success", summary: "Success", detail: "Login successful!", life: 3000 });

                } else if (UserRole === "ContentManager") {
                    router.push("/content-manager/dashboard")
                    toast.current?.show({ severity: "success", summary: "Success", detail: "Login successful!", life: 3000 });

                } else if (UserRole === 'ContentHead') {
                    router.push("/content-head/dashboard")
                    toast.current?.show({ severity: "success", summary: "Success", detail: "Login successful!", life: 3000 });
                } else if (UserRole === "Volunteer") {
                    router.push("/volunteer/dashboard")
                    toast.current?.show({ severity: "success", summary: "Success", detail: "Login successful!", life: 3000 });
                } else if (UserRole === "ClusterReasearchPerson") {
                    router.push("/crp/dashboard")
                }

                else if (UserRole === "Teacher") {
                    toast.current?.show({
                        severity: "error",
                        summary: "Access Denied",
                        detail: "Your account does not have permission to access the web portal."
                    });
                    return;
                } else {
                    router.push("/dashboard");

                }
            } else if (response?.errors[0] === 'USER_IS_DEACTIVATED') {
                toast.current?.show({
                    severity: "error",
                    summary: "Error",
                    detail: "Your account has been deactivated. Please contact the administrator for assistance.",
                    life: 3000,
                });
            } else {
                toast.current?.show({ severity: "error", summary: "Error", detail: response.message || "Login failed", life: 3000 });
            }
        } catch (error: any) {
            if (error === "USER_IS_DEACTIVATED") {
                toast.current?.show({
                    severity: "error",
                    summary: "Account Deactivated",
                    detail: "Your account has been deactivated. Please contact the administrator.",
                    life: 3000,
                });
            } else {
                toast.current?.show({ severity: "error", summary: "Error", detail: error?.response?.message || "Something went wrong", life: 3000 });
            }
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="space-y-6">
            <Toast ref={toast} />
            {/* Email */}
            <div className="space-y-2">
                <Input
                    id="contact"
                    type="text"   // ✅ change here
                    label="Mobile Number"
                    value={contact}
                    onChange={(e) => handleChange(e, "contact")}
                    autoComplete="off"
                    aria-label="Mobile Number"
                    error={errors.contact}
                    placeholder="Enter mobile number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={10}
                    className="text-slate-900"
                />
            </div>
            {/* Password */}
            <PasswordInput
                id="password"
                label="Password"
                value={password}
                onChange={(e) => handleChange(e, "password")}
                error={errors.password}
                placeholder="Enter your password"
                showStrength
                className=""
            />

            {/* Remember & Forgot */}
            <div className="flex items-center justify-between text-sm">
                <label className="flex items-center ">
                    {/* <input
                        type="checkbox"
                        className=" accent-blue-600 border-gray-300 rounded"
                    />
                    <span className="ml-2 text-gray-600 ">Remember me</span> */}
                </label>
                <Link
                    href="/forgot-password"
                    className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
                >
                    Forgot password?
                </Link>

            </div>

            {/* Login Button */}
            <Button onClick={handleLogin} disabled={isLoading}>
                {isLoading ? (
                    <span className="flex align-items-center justify-content-center gap-2 ">
                        <i className="pi pi-spinner pi-spin" />
                        Signing in...
                    </span>
                ) : (
                    "Sign In"
                )}
            </Button>

        </div>

    )
}

export default LoginForm
